"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_generated_exports = {};
__export(types_generated_exports, {
  isBannerMessage: () => isBannerMessage,
  isBannerMessageHighlight: () => isBannerMessageHighlight,
  isKnownWorkspaceFeature: () => isKnownWorkspaceFeature,
  isWorkspace: () => isWorkspace,
  isWorkspaceEmailSettings: () => isWorkspaceEmailSettings,
  isWorkspaceFeature: () => isWorkspaceFeature,
  isWorkspaceJoinerEmailSettings: () => isWorkspaceJoinerEmailSettings,
  isWorkspaceLimits: () => isWorkspaceLimits,
  isWorkspaceLimitsCheckResult: () => isWorkspaceLimitsCheckResult,
  isWorkspaceSearchRoleParam: () => isWorkspaceSearchRoleParam,
  isWorkspaceUsage: () => isWorkspaceUsage
});
module.exports = __toCommonJS(types_generated_exports);
var import_types_generated = require("../core/types.generated.js");
const isBannerMessageHighlight = (v) => {
  return v === "default" || v === "info" || v === "success" || v === "warning" || v === "error";
};
const isBannerMessage = (v) => {
  return typeof v === "object" && v != null && "text" in v && typeof v.text === "string" && (!("highlight" in v) || isBannerMessageHighlight(v.highlight) || v.highlight === null);
};
const isWorkspaceUsage = (v) => {
  return typeof v === "object" && v != null && "numUsers" in v && typeof v.numUsers === "number" && "numPendingInvitations" in v && typeof v.numPendingInvitations === "number" && "numUnapprovedSignups" in v && typeof v.numUnapprovedSignups === "number";
};
const isWorkspaceLimits = (v) => {
  return typeof v === "object" && v != null && (!("maxUsers" in v) || typeof v.maxUsers === "number" || v.maxUsers === null);
};
const isWorkspaceLimitsCheckResult = (v) => {
  return typeof v === "object" && v != null && "hasRoom" in v && typeof v.hasRoom === "boolean";
};
const isWorkspaceJoinerEmailSettings = (v) => {
  return typeof v === "object" && v != null && "toAdmins" in v && typeof v.toAdmins === "boolean" && "toAddresses" in v && Array.isArray(v.toAddresses) && v.toAddresses.every((i) => (0, import_types_generated.isNamedEmail)(i));
};
const isWorkspaceEmailSettings = (v) => {
  return typeof v === "object" && v != null && "invitation" in v && (0, import_types_generated.isInvitationEmailSettings)(v.invitation) && "joiner" in v && isWorkspaceJoinerEmailSettings(v.joiner);
};
const isKnownWorkspaceFeature = (v) => {
  return v === "EnableMobile" || v === "OfflineMaps" || v === "EnableArcgisIntegration" || v === "EnableInvitationCodes" || v === "EnableTeams" || v === "PreferTeams" || v === "LockAlias";
};
const isWorkspaceFeature = (v) => {
  return v === "EnableMobile" || v === "OfflineMaps" || v === "EnableArcgisIntegration" || v === "EnableInvitationCodes" || v === "EnableTeams" || v === "PreferTeams" || v === "LockAlias" || typeof v === "string";
};
const isWorkspace = (v) => {
  return typeof v === "object" && v != null && "name" in v && typeof v.name === "string" && "alias" in v && (0, import_types_generated.isWorkspaceAlias)(v.alias) && (!("operator" in v) || typeof v.operator === "string" || v.operator === null) && (!("homepage" in v) || typeof v.homepage === "string" || v.homepage === null) && (!("logo" in v) || typeof v.logo === "string" || v.logo === null) && (!("privacyPolicy" in v) || typeof v.privacyPolicy === "string" || v.privacyPolicy === null) && "features" in v && Array.isArray(v.features) && v.features.every((i) => isWorkspaceFeature(i)) && "accessLevel" in v && (0, import_types_generated.isWorkspaceAccessLevel)(v.accessLevel) && "id" in v && (0, import_types_generated.isWorkspaceId)(v.id);
};
const isWorkspaceSearchRoleParam = (v) => {
  return v === "all" || v === "registered" || v === "active";
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isBannerMessage,
  isBannerMessageHighlight,
  isKnownWorkspaceFeature,
  isWorkspace,
  isWorkspaceEmailSettings,
  isWorkspaceFeature,
  isWorkspaceJoinerEmailSettings,
  isWorkspaceLimits,
  isWorkspaceLimitsCheckResult,
  isWorkspaceSearchRoleParam,
  isWorkspaceUsage
});
//# sourceMappingURL=types.generated.js.map
